import { render, staticRenderFns } from "./playerSet.vue?vue&type=template&id=5d0b2172&scoped=true&"
import script from "./playerSet.vue?vue&type=script&lang=js&"
export * from "./playerSet.vue?vue&type=script&lang=js&"
import style0 from "./playerSet.vue?vue&type=style&index=0&id=5d0b2172&prod&lang=less&scoped=true&"
import style1 from "./playerSet.vue?vue&type=style&index=1&id=5d0b2172&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b2172",
  null
  
)

export default component.exports